/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Roster_CapacityInputs */

const en_roster_capacity = /** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacity`)
};

const es_roster_capacity = /** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacidad`)
};

const fr_roster_capacity = /** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Capacité`)
};

const de_roster_capacity = /** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapazität`)
};

const id_roster_capacity = /** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapasitas`)
};

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const ja_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const zh_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const ar_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const it_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const ru_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const pt_roster_capacity = en_roster_capacity;

/** @type {(inputs: Roster_CapacityInputs) => LocalizedString} */
const ko_roster_capacity = en_roster_capacity;

/**
* | output |
* | --- |
* | "Capacity" |
*
* @param {Roster_CapacityInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const roster_capacity = /** @type {((inputs?: Roster_CapacityInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Roster_CapacityInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_roster_capacity(inputs)
	if (locale === "es") return es_roster_capacity(inputs)
	if (locale === "fr") return fr_roster_capacity(inputs)
	if (locale === "de") return de_roster_capacity(inputs)
	if (locale === "ja") return ja_roster_capacity(inputs)
	if (locale === "zh") return zh_roster_capacity(inputs)
	if (locale === "ar") return ar_roster_capacity(inputs)
	if (locale === "id") return id_roster_capacity(inputs)
	if (locale === "it") return it_roster_capacity(inputs)
	if (locale === "ru") return ru_roster_capacity(inputs)
	if (locale === "pt") return pt_roster_capacity(inputs)
	return ko_roster_capacity(inputs)
});